<template lang="pug">
  b-overlay(:show="loading", variant="transparent", spinner-variant="primary")
    b-card
      transition(name="fade")
        b-form.mb-4(v-if="edit_mode")
          b-form-group.mb-1(label-size="sm")
            template(#label)
              .d-flex.justify-content-between.align-items-center
                p.mb-0 Nombre
                b-form-row.mt-2.mt-md-0.justify-content-end.justify-content-md-start.align-items-center
                  b-col.mr-3(cols="auto")
                    b-button(variant="outline-primary", size="sm", @click="edit_mode = false")
                      minimize-2-icon.icon-md
                  b-col(cols="auto")
                    b-form-checkbox(switch, v-model="objective.enabled", @change="updateObjective") {{objective.enabled ? 'Activado' : 'Desactivado'}}
                  b-col(cols="auto")
                    trash-2-icon.icon-md.hover-danger.pointer.text-secondary(@click="confirmDestroy")
            b-form-input(placeholder="Nombre del Objetivo", v-model="objective.name", @input="updateObjective")
          b-form-group.mb-1(label="Descripción", label-size="sm")
            b-form-textarea(placeholder="Descripción", v-model="objective.description", rows="1", max-rows="2", no-resize, @input="updateObjective")
          b-form-group(label-size="sm")
            template(#label)
              .d-flex.justify-content-between.align-items-center
                div Ramificaciones
                b-button(variant="outline-primary", :disabled="loading_branch", size="sm", @click="addBranch")
                  b-spinner(small, variant="primary", v-if="loading_branch")
                  plus-icon.icon-md(v-else)
            b-input-group(v-for="(branch, index) in objective.branches", :key="index", size="sm" )
              b-form-input(placeholder="Nombre de rama", :value="branch", @input="updateBranch", :disabled="loading_branch")
              b-input-group-append
                b-button(variant="soft-danger", :disabled="loading_branch", @click="destroyBranch(branch)")
                  trash-icon.icon-md
      .mb-2(v-if="!edit_mode")
        .d-flex.align-items-center.justify-content-between
          h4.mb-0 {{objective.name}}
          b-col.m-0.p-0.d-flex.justify-content-end
            b-spinner.mr-2.d-flex.align-self-center(small, variant='primary', v-if="isDownloadingReport")
            b-button.mr-2(variant="outline-primary", size="sm", @click="edit_mode = true")
              edit3-icon.icon-md
            b-button(variant="outline-primary", size="sm", @click="downloadReport")
              download-icon.icon-md
        .text-secondary {{objective.description}}
      b-row.align-items-center.mb-3
        b-col
          h4.mb-0 Tasa de conversión
        b-col.text-right
          date-range-picker(v-bind="calendarProps", v-model="dates", :maxDate="$moment().format()", @update="getObjective")
            template.w-100(v-slot:input="picker")
              b-input-group
                b-form-input.readonly-white(placeholder="Seleccionar fecha...", :value="parse_dates", readonly)
                b-input-group-append
                  b-input-group-text
                    calendar-icon.text-secondary.icon-sm
      b-row.no-gutters.mb-1.bb-1.align-items-center(v-if="hasBranches")
        b-col.text-secondary.text-sm.px-2(cols="6") Ramificaciones
        b-col(cols="6")
          b-form-row.text-center.align-items-center
            b-col(v-for="(el, branch) in selectedBranches", :key="branch")
              b-form-select(v-model="selectedBranches[branch]", size="sm" )
                template(#first)
                  b-form-select-option(:value="null" disabled) -- Comprar rama --
                  b-form-select-option(v-for="(branch, index) in compareBranches", :key="index", :value="branch") {{branch === 'main' ? 'Principal' : branch}}
      .funnel.mb-4
        b-row.align-items-center(no-gutters, v-for="step in objective.steps", :key="step._id", v-show="edit_mode ? true : step.enabled")
          b-col.layer-label
            b-overlay(:show="loading_step === step._id", variant="white", spinner-small, spinner-variant="primary")
              b-input-group(size="sm")
                transition(name="fade")
                  b-input-group-prepend(is-text, v-if="edit_mode")
                    b-form-checkbox(switch, v-model="step.enabled", @change="updateStep(step)") {{step.enabled ? 'On' : 'Off'}}
                b-form-input.border-bottom-0.bg-white.rounded(placeholder="Titulo", :class="{'border-0': !edit_mode || !step.enabled}" :disabled="!edit_mode || !step.enabled", :style="{'opacity': !!step.enabled ? '1' : '0.2'}", v-model="step.title", @input="updateStep(step)")
          b-col
            b-form-row.h-100.w-100.position-absolute.align-items-center.m-0.text-white.text-center(v-if="hasBranches")
              b-col(style="z-index:10;", v-for="(el, branch) in selectedBranches", :key="branch", :class="{'bl-1' : branch === 'second'}")
                span(:class="branch") {{step.counts ? step.counts[el] || '-' : '-'}}
            .h-100.w-100.position-absolute.pt-1.text-white.text-center(style="z-index:10;", v-else) {{step.counts ? step.counts.main : '-'}}
            .layer.mx-auto(:style="{'opacity': step.enabled ? '1' : '0.2'}")
        b-row.align-items-center.mb-2(no-gutters)
          b-col.layer-label.text-center
            .font-weight-bold.text-primary.pt-1(style="height:31px") Tasa de conversión
              span.ml-2(v-if="!hasBranches") {{objective.rates.main || '0%'}}
          b-col
            b-form-row.h-100.w-100.position-absolute.align-items-center.m-0.text-primary.text-center(v-if="hasBranches")
              b-col(style="z-index:10;", v-for="(el, branch) in selectedBranches", :key="branch", :class="{'bl-1' : branch === 'second'}")
                span(:class="branch") {{objective.rates[el] || '0%'}}
            .layer.mx-auto
        //.text-right(v-if="edit_mode")
          b-button(variant="primary", @click="edit_mode = false") Guardar
      canvas#rates-chart
      canvas#dates-chart
</template>

<script>
import axios from 'axios'
import Chart from 'chart.js'
import Days from '../data/days'
import Download from 'downloadjs'
import _debounce from 'lodash.debounce'
import { mapActions } from 'vuex'
import Months from '../data/months'
import threeSelectOptions from '../data/treeselect-options'
import KolorWheel from "kolorwheel"

const timeZone = require('moment-timezone')
const ERROR_REPORT = 'No logramos generar el reporte, por favor comprueba tu conexión a internet'
const API_URL = process.env.VUE_APP_REPORTS

export default {
  data () {
    return {
      threeSelectOptions: threeSelectOptions,
      loading: false,
      edit_mode: false,
      loading_step: null,
      loading_branch: false,
      isDownloadingReport: false,
      chart: null,
      datesChart: null,
      selectedBranches: {
        first: 'main',
        second: ''
      },
      calendarProps: {
        linkedCalendars: false,
        showDropdowns: true,
        ranges: false,
        opens: 'left',
        localeData: {
          applyLabel: 'Aplicar',
          cancelLabel: 'Cancelar',
          daysOfWeek: Days.daysShort,
          monthNames: Months.monthsShort,
          firstDay: 0
        },
        parentEl: '#router-container'
      },
      objective: {
        name: '',
        description: '',
        enabled: false,
        branches: [],
        steps: [],
        rates: {},
        branchData: {},
        rateByDate: {}
      },
      dates: {
        startDate: null,
        endDate: null,
      },
      steps: [],
    }
  },
  computed: {
    parse_dates () {
      return this.$moment(this.dates.startDate).format('DD MMM YYYY') + ' - ' + this.$moment(this.dates.endDate).format('DD MMM YYYY')
    },
    compareBranches () {
      return ['main', ...this.objective.branches]
    },
    hasBranches () {
      return !!this.objective.branches.length
    },
    download_path() {
      let { startDate, endDate } = this.dates
      let path = `${API_URL}report/objective/${this.$route.params.objective_id}?`

      if (startDate && endDate) {
        startDate = timeZone(startDate).format('YYYY-MM-DD')
        endDate = timeZone(endDate).format('YYYY-MM-DD')

        path += `startDate=${startDate}&endDate=${endDate}`
      }

      return path
    }
  },
  methods: {
    ...mapActions([
      'objective/get',
      'objective/update',
      'objective/destroy',
      'objective/updateStep',
      'objective/createBranch',
      'objective/updateBranch',
      'objective/destroyBranch',
      'account/get'
    ]),
    getObjective () {
      const self = this
      this.loading = true

      this['objective/get']({
        objective_id: self.$route.params.objective_id,
        params: {
          init_date: this.dates.startDate,
          final_date: this.dates.endDate
        },
        callback: res => {
          self.loading = false
          if (res.error) return self.$message.error(res.error)

          self.objective = Object.assign(self.objective, res.resource)
          if(self.objective.branches.length) {
            self.selectedBranches.second = self.objective.branches[0]
          }

          self.createRatesChart()
          self.createDatesChart()
        }
      })
    },
    updateObjective: _debounce(function () {
      const self = this
      this.loading = true

      this['objective/update']({
        ...this.objective,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Objetivo actualizado')
          }
        }
      })
    }, 1000, { leading: false, trailing: true }),
    confirmDestroy () {
      this.$bvModal.msgBoxConfirm('¿Deseas eliminar el objetivo? No se puede deshacer.', {
        title: 'Eliminar objetivo',
        okTitle: 'Eliminar',
        okVariant: 'danger',
        cancelTitle: 'Cancelar'
      }).then(value => {
        if (value === true) {
          this.destroyObjective()
        }
      })
    },
    destroyObjective () {
      const self = this
      this.loading = true

      this['objective/destroy']({
        ...this.objective,
        callback: res => {
          self.loading = false
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$router.push({name: 'Objectives'}).catch(()=>{});
          }
        }
      })
    },
    updateStep: _debounce(function (step) {
      if(!step.title) return
      const self = this
      this.loading_step = step._id

      this['objective/updateStep']({
        objective_id: this.$route.params.objective_id,
        ...step,
        callback: res => {
          self.loading_step = null
          if (res.error) {
            self.$message.error(res.error)
          } else {
            self.$message.success('Objetivo actualizado')
          }
        }
      })
    }, 1000, { leading: false, trailing: true }),
    createRatesChart () {
      if (this.chart) this.chart.destroy()

      const { branchData = {}, steps } = this.objective
      const keys = Object.keys(branchData)
      const hasNonEmptyArr = keys.some(key => branchData[key].length)
      const datasets = []

      if(!hasNonEmptyArr) return

      const enabledSteps = steps.filter(({enabled}) => enabled)
      const enabledIndex = enabledSteps.map(({index}) => index)

      for (let [index, key] of keys.entries()) {
        const totals = branchData[key]

        let color = new KolorWheel([100*(++index), 80, 75])
        color = color.getHex()

        const data = totals.filter(({_id}) => enabledIndex.includes(_id)).map(({total}) => total)

        datasets.push({
          label: key === 'main' ? 'Principal' : key,
          data,
          pointBackgroundColor: color,
          borderColor: color,
          pointRadius: 6,
          pointHoverRadius: 8,
          lineTension: 0.1
        })
      }

      const labels = enabledSteps.map(({title}) => title)

      this.chart = this.createChart('rates-chart', labels, datasets)
    },
    createDatesChart () {
      if (this.datesChart) this.datesChart.destroy()

      const { rateByDate = [] } = this.objective
      const keys = Object.keys(rateByDate)
      const hasNonEmptyArr = keys.some(key => rateByDate[key].length)
      const datasets = []

      if(!hasNonEmptyArr) return

      let dates = []

      for (let [index, key] of keys.entries()) {
        const rates = rateByDate[key]

        dates = dates.concat(rates.map(({date}) => date))

        let color = new KolorWheel([100*(++index), 80, 75])
        color = color.getHex()

        const data = rates.map(({rate}) => rate)

        datasets.push({
          label: key === 'main' ? 'Principal' : key,
          data,
          pointBackgroundColor: color,
          borderColor: color,
          pointRadius: 6,
          pointHoverRadius: 8,
          lineTension: 0.1
        })
      }

      const labels = dates.filter((item, index, self) => self.indexOf(item) === index)

      const scales = {
        yAxes: [{
          ticks: {
            callback: function(value) {
              return `${value}%`
            }
          }
        }],
      }
      const tooltips = {
        callbacks: {
          label: function(tooltipItem) {
            return `Tasa de conversión ${tooltipItem.value}%`
          }
        }
      }

      this.datesChart = this.createChart('dates-chart', labels, datasets, scales, tooltips)
    },
    createChart (id, labels, datasets, scales, tooltips) {

      const options = {
        responsive: true,
        maintainAspectRatio: true,
        elements: {
          line: { fill: false }
        }
      }

      if(scales) options.scales = scales
      if(tooltips) options.tooltips = tooltips

      return new Chart(id, {
        type: 'line',
        data: { labels, datasets },
        options
      })
    },
    async downloadReport() {
      try {
        this.isDownloadingReport = true
        this.$message.info('Generando reporte...')

        const res = await axios.get(this.download_path, { responseType: 'blob' })

        if (res.status !== 200) return this.$message.error('Error al generar reporte')
        if (res.error) return this.$message.warning(ERROR_REPORT)

        this.$message.success('Reporte generado')
        this.isDownloadingReport = false

        Download(res.data, 'Reporte_objetivos.xlsx', res.headers['content-type'])
      } catch (e) {
        this.$message.warning(ERROR_REPORT)
        this.isDownloadingReport = false

        console.error(e.message)
      }
    },
    addBranch () {
      const self = this
      this.loading_branch = true
      const branch = 'Nueva Rama'

      this['objective/createBranch']({
        objective_id: self.$route.params.objective_id,
        branch,
        callback: res => {
          self.loading_branch = false
          if (res.error)  return self.$message.error(res.error)
          self.objective.branches.push(branch)
          self.$message.success('Rama creada')
        }
      })
    },
    updateBranch: _debounce(function (branch) {
      const self = this
      this.loading_branch = true

      this['objective/updateBranch']({
        objective_id: self.$route.params.objective_id,
        branch,
        callback: res => {
          self.loading_branch = false
          if (res.error)  return self.$message.error(res.error)
          self.objective.branches = [branch]
          self.$message.success('Rama actualizada')
        }
      })
    }, 1000, { leading: false, trailing: true }),
    destroyBranch (branch) {
      const self = this
      this.loading_branch = true

      this['objective/destroyBranch']({
        objective_id: self.$route.params.objective_id,
        branch,
        callback: res => {
          self.loading_branch = false
          if (res.error)  return self.$message.error(res.error)
          self.objective.branches = []
          self.$message.success('Rama eliminada')
        }
      })
    }
  },
  mounted() {
    this.dates.startDate = this.$moment().subtract(1, 'w').format();
    this.dates.endDate = this.$moment().format()
    this.getObjective()
  }
}
</script>

<style lang="scss" scoped>

  .funnel .row {

    .input-group-text {
      border: 0;
    }

    .layer, .underline {
      animation: grow 0.4s ease-in-out;
      -webkit-animation-fill-mode: forwards;
      -moz-animation-fill-mode: forwards;
      -ms-animation-fill-mode: forwards;
      -o-animation-fill-mode: forwards;
      animation-fill-mode: forwards;
      transform: scaleX(0);
    }

    &:nth-child(1) {
      .layer {
        border-left: 30px solid transparent;
        border-right: 30px solid transparent;
        border-top: 33px solid #7f559e;
      }
      .layer-label, .underline { border-bottom: 1px solid #7f559e; }
      input { color: #7f559e; }
    }

    &:nth-child(2) {
      .layer {
        border-left: 25px solid transparent;
        border-right: 25px solid transparent;
        border-top: 33px solid #ff7069;
        width: 75%;
        animation-delay: 0.1s;
      }
      .layer-label, .underline { border-bottom: 1px solid #ff7069; }
      input { color: #ff7069; }
      .first { margin-left: 25%; }
      .second { margin-right: 25% }
    }

    &:nth-child(3) {
      .layer {
        border-left: 20px solid transparent;
        border-right: 20px solid transparent;
        border-top: 33px solid #86dc56;
        width: 55%;
        animation-delay: 0.2s;
      }
      .layer-label, .underline { border-bottom: 1px solid #86dc56; }
      input { color: #86dc56; }
      .first { margin-left: 45%; }
      .second { margin-right: 45% }
    }

    &:nth-child(4) {
      .layer {
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 33px solid #30ccc3;
        width: 35%;
        animation-delay: 0.3s;
      }
      .layer-label, .underline { border-bottom: 1px solid #30ccc3; }
      input { color: #30ccc3; }
      .first { margin-left: 70%; }
      .second { margin-right: 70% }
    }

    &:nth-child(5) {
      .layer {
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 33px solid #f5a15b;
        width: 20%;
        animation-delay: 0.4s;
      }
      .layer-label, .underline { border-bottom: 1px solid #f5a15b; }
      input { color: #f5a15b }
      .first { margin-left: 87%; }
      .second { margin-right: 87% }
    }

    &:nth-child(6) {
      .layer {
        border-left: 5px solid transparent;
        border-right: 5px solid transparent;
        border-top: 32px solid var(--primary);
        width: 10%;
        animation-delay: 0.5s;
      }
      .layer-label, .underline { border-bottom: 1px solid var(--primary); }
      input { color: var(--primary); }
    }
  }

  @keyframes grow {
    from {
      transform: scaleX(0);
    }
    to {
      transform: scaleX(1);
    }
  }

  .fade-enter-active, .fade-leave-active {
    transition: opacity .3s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

</style>
